// Availability is a server-owned account policy, never browser preferences.
export function toolAvailable(data,id){
  // New tools must be explicitly admitted by the server even when the legacy
  // tool-control rollout is inactive. Never extend that fallback to this gate.
  const explicit=data?.tools?.some(tool=>tool.id===id&&tool.available===true)===true
  return id==='cc.artworkcreated'?data?.active===true&&explicit:data?.active===false||explicit
}
export function toolNeedsAdmission(id){return id.startsWith('cc.')||id.startsWith('platform.')}
